import * as React from 'react';
import classNames from 'classnames';
import styles from './collection-line-value.scss';
import { IFilterValueProps } from '../filterValue/filter-value.d';
import InfoIcon from '../../../Assets/svg/info';
import TabNavigationHelper from '../../../Common/tabNavigationHelper';
import { CollectionLineContext } from '../../../Common/contexts/collectionLineContext'
/*
    Displays a single collection line inside the filter, such as e.s.dynashield
*/
export default class CollectionLineValue extends React.Component<IFilterValueProps> {
    declare context: React.ContextType<typeof CollectionLineContext>
    static contextType = CollectionLineContext;

    private tabNav: TabNavigationHelper;

    constructor(props) {
        super(props);
        this.state = {};
        this.tabNav = TabNavigationHelper.instance;
        this.onValueClicked = this.onValueClicked.bind(this);
        this.onTooltipClicked = this.onTooltipClicked.bind(this);
    }

    public render() {
        const isDisabled = this.props.filterPropertyValue.articlesAmount === 0;
        const collectionLineConfig = this.context.getCollectionConfigById(this.props.filterPropertyValue.id);
        if (!collectionLineConfig) {
            return null;
        }
        const { svgClassName, tooltipImageClassname } = collectionLineConfig;
        const isMisconfigured =
            // The icon for the collection line list is missing    
            !svgClassName
            || (!tooltipImageClassname && !!this.props.filterPropertyValue.tooltip)
        if (isMisconfigured) {
            return null;
        }
        return (
            <div
                className={classNames(styles.filter_colection_line_value,
                    {
                        [styles.selected_value]: this.props.isSelected,
                        [styles.disabled_value]: isDisabled
                    })}
                data-testid='filter_colection_line_value'
                ref={(el) => {
                    if (!isDisabled)
                        this.tabNav.setFocusAtt(el);
                }}
                onClick={this.onValueClicked}
                onKeyDown={this.tabNav.handleKeyDown}
            >
                {this.props.filterPropertyValue.iconSrc ?
                    (
                        <div className={styles.icon_container}>
                            <img src={this.props.filterPropertyValue.iconSrc} loading='lazy' />
                        </div >
                    )
                    : null
                }
                {/*
                  Each Collection Line has a unique ID, and an associated SVG image.
                  Each SVG Image is configured as a background image through a CSS class.
                  We check the collection line ID and dynamically select the appropriate CSS class,
                    thus displaying the appropriate SVG background image.
                */}
                <div className={classNames(styles.collection_line_image,
                    {
                        [styles[collectionLineConfig.svgClassName]]: !!styles[collectionLineConfig.svgClassName]
                    }
                )} />
                <div className={styles.filter_title}>
                    {this.props.filterPropertyValue.title}
                </div>
                <div className={styles.article_amount}>
                    {this.props.filterPropertyValue.articlesAmount}
                    {/*
                        Clicking the tooltip icon will open a little modal, describing this particular collection line.
                        Since BSITE doesn't enforce the existence of a tooltip value, it can be that a collection line does 
                            not have one. We should hide the i tooltip button if there's nothing to display.
                    */}
                    {!!this.props.filterPropertyValue.tooltip && (<span className={styles.icon_tooltip}
                        data-testid='icon_tooltip'
                        onClick={this.onTooltipClicked}
                        ref={(el) => {
                            if (!isDisabled)
                                this.tabNav.setFocusAtt(el);
                        }}>
                        <InfoIcon />
                    </span>)}

                </div>
            </div>
        );
    }

    private onValueClicked() {
        if (this.props.isSelected)
            this.props.removeSelectedFilter(this.props.filter);
        else
            this.props.addSelectedFilter(this.props.dimension, this.props.filterPropertyValue);
    }

    private onTooltipClicked(event: React.MouseEvent) {
        event.preventDefault();
        event.stopPropagation();
        const collectionLineConfig = this.context.getCollectionConfigById(this.props.filterPropertyValue.id)
        if (collectionLineConfig) {
            this.props.updateTooltip(
                true,
                this.props.filterPropertyValue.tooltip,
                collectionLineConfig.tooltipImageClassname
            );
        }
    }
}
